module.exports = __webpack_public_path__ + "img/1085w.8d91783.jpg";